/**
 * Header tag to use for TOC.
 */
export const TOC_HEADER_TAG = 'h2';
